import React, { useState } from 'react';
import { FaCheckCircle, FaBriefcase, FaGraduationCap, FaCertificate, FaArrowRight, FaCode, FaCloud, FaDatabase, FaNetworkWired, FaServer, FaHandshake } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const rolesData = [
  {
    id: 'software',
    title: 'Software Engineer',
    icon: <FaCode size={22} />,
    matchRate: '98% Match',
    color: '#45aaf2',
    summary: 'Strong full-stack foundation using React, Node.js, Express, Python, and C. Experience building responsive web platforms, RESTful APIs, and implementing modular software design with clean Git/GitHub workflows.',
    coreSkills: ['React.js & Web UI', 'Node.js & REST APIs', 'Python Development', 'C Programming', 'Version Control (Git/GitHub)', 'Responsive UI/UX Architecture'],
    certifications: ['AWS Academy Cloud Architecting', 'AWS Academy Cloud Semester 1 & 2', 'B.Sc. Information & Communication Tech (Smart IoT)'],
    starImpact: 'Built Eastland Top Tutors full-stack educational platform with real-time scheduling, user auth, and scalable database integration.',
    hrActionText: 'Inquire for Software Role',
    contractActionText: 'Hire for Web/App Development Contract'
  },
  {
    id: 'cloud',
    title: 'Cloud Engineer',
    icon: <FaCloud size={22} />,
    matchRate: '97% Match',
    color: '#00d2d3',
    summary: 'Specialized in multi-cloud architecture (AWS & Azure), Infrastructure as Code (Terraform), containerization (Docker), and orchestration (Kubernetes, OpenShift, VMware).',
    coreSkills: ['AWS Cloud Architecting', 'Infrastructure as Code (Terraform)', 'Containerization (Docker)', 'Kubernetes & Red Hat OpenShift', 'VMware & Cloud Migration', 'CI/CD & Cost Optimization'],
    certifications: ['AWS Academy Graduate - Cloud Architecting', 'Red Hat Academy Program Learner (2024)', 'AWS Academy Cloud Semester 1 & 2'],
    starImpact: 'Architected automated, high-availability multi-region cloud deployment templates using Terraform and Docker containers with strict security hardening.',
    hrActionText: 'Inquire for Cloud Role',
    contractActionText: 'Hire for Cloud Migration / IaC Contract'
  },
  {
    id: 'data',
    title: 'Data Analyst',
    icon: <FaDatabase size={22} />,
    matchRate: '95% Match',
    color: '#f8d210',
    summary: 'I combine academic background in Physics & Circular Economy (M.Sc) with technical data analysis, Python scripting, SQL database design, statistical modeling (SPSS), and visual reporting dashboards (Grafana).',
    coreSkills: ['Python Data Analytics', 'SQL & Database Management', 'SPSS Statistical Analysis', 'Grafana Data Dashboards', 'Data Wrangling & Cleaning', 'Quantitative Research & Modeling'],
    certifications: ['Master of Science (M.Sc), Circular Economy (LUT Finland)', 'Bachelor of Science (B.Sc), Physics (Univ. of Ibadan)'],
    starImpact: 'Conducted complex statistical analyses and built real-time metrics dashboards, enabling data-driven operational decisions and process optimization.',
    hrActionText: 'Inquire for Data Analyst Role',
    contractActionText: 'Hire for Data Analytics & Dashboard Contract'
  },
  {
    id: 'network',
    title: 'Network Engineer',
    icon: <FaNetworkWired size={22} />,
    matchRate: '98% Match',
    color: '#2ecc71',
    summary: 'Cisco-certified in switching, routing, wireless essentials, CyberOps, and ethical hacking. Proficient in configuring VLANs, VPNs, firewalls, and subnets.',
    coreSkills: ['Cisco Routing & Switching', 'VLAN & VPN Configuration', 'Network Hardening & Firewalls', 'CyberOps & Threat Detection', 'Ethical Hacking Fundamentals', 'Cisco Packet Tracer Simulations'],
    certifications: ['CCNA: Switching, Routing, and Wireless Essentials', 'Cisco CyberOps Associate', 'Cisco Ethical Hacker'],
    starImpact: 'Designed and verified secure corporate network topologys using Cisco switches, routers, and firewall rules with zero-downtime failover logic.',
    hrActionText: 'Inquire for Network Role',
    contractActionText: 'Hire for Network Setup / Hardening Contract'
  },
  {
    id: 'it',
    title: 'IT Specialist / Systems Admin',
    icon: <FaServer size={22} />,
    matchRate: '96% Match',
    color: '#9b59b6',
    summary: 'Proven history in IT customer support, systems installation, Smart IoT devices, Linux administration, and technical troubleshooting across enterprise environments.',
    coreSkills: ['Linux System Administration', 'IoT Smart Systems (Raspberry Pi)', 'Technical Support & Helpdesk', 'OS Installation & Hardening', 'Customer Care & SLA Management', 'Technical Documentation'],
    certifications: ['Red Hat Academy Learner', 'B.Sc. Information Technology (Metropolia UAS)', 'Customer Support Specialist Background'],
    starImpact: 'Managed high-volume technical support operations with high SLA compliance while installing, configuring, and troubleshooting complex operating environments.',
    hrActionText: 'Inquire for IT / SysAdmin Role',
    contractActionText: 'Hire for IT Support / IoT Systems Contract'
  },
  {
    id: 'consulting',
    title: 'Contractor / Tech Consultant',
    icon: <FaHandshake size={22} />,
    matchRate: '100% Available',
    color: '#e74c3c',
    summary: 'Available for freelance contracts, technical consulting, architecture reviews, website design & build, and cloud infrastructure setup for businesses and startups.',
    coreSkills: ['Full-Stack Web Development', 'Cloud Architecture Audit & Setup', 'Network Security Hardening', 'Audio/Graphics Content & Branding', 'Technical Project Management', 'Custom IT Advisory'],
    certifications: ['Multi-Disciplinary M.Sc & B.Sc Degrees', 'AWS & Cisco Professional Badges', '5+ Years Entrepreneurial & Client Delivery'],
    starImpact: 'Successfully delivered custom client projects on time and within budget, delivering measurable efficiency gains and robust digital footprints.',
    hrActionText: 'Discuss Part-Time / Advisory Role',
    contractActionText: 'Request Project Quote & Consultation'
  }
];

const HrRoleMatcher = () => {
  const [activeRole, setActiveRole] = useState('software');
  const selectedRole = rolesData.find(r => r.id === activeRole) || rolesData[0];

  return (
    <div style={{ width: '100%', maxWidth: '1100px', margin: '0 auto', padding: '20px 0' }}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <span className="badge badge-gold" style={{ marginBottom: '12px' }}>
          🎯 Interactive Candidate & Contract Matcher
        </span>
        <h2 style={{ fontSize: '2.2rem', color: '#ffffff', margin: '8px 0' }}>
          Evaluate Alignment for Your Open Role or Contract
        </h2>
        <p style={{ color: '#94a3b8', maxWidth: '700px', margin: '0 auto', fontSize: '1.05rem' }}>
          Click a track below to instantly see how my experience, certifications, and technical capabilities map to your organization’s requirements.
        </p>
      </div>

      {/* Role Navigation Tabs */}
      <div style={{
        display: 'flex',
        justify: 'center',
        flexWrap: 'wrap',
        gap: '12px',
        marginBottom: '32px'
      }}>
        {rolesData.map(role => {
          const isActive = role.id === activeRole;
          return (
            <button
              key={role.id}
              onClick={() => setActiveRole(role.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '12px 20px',
                borderRadius: '30px',
                border: isActive ? `2px solid ${role.color}` : '1px solid rgba(255,255,255,0.15)',
                background: isActive ? `rgba(${hexToRgb(role.color)}, 0.2)` : 'rgba(16, 37, 66, 0.6)',
                color: isActive ? '#ffffff' : '#94a3b8',
                fontWeight: isActive ? '700' : '500',
                cursor: 'pointer',
                transition: 'all 0.25s ease',
                boxShadow: isActive ? `0 4px 18px rgba(${hexToRgb(role.color)}, 0.3)` : 'none'
              }}
            >
              <span style={{ color: role.color }}>{role.icon}</span>
              <span>{role.title}</span>
            </button>
          );
        })}
      </div>

      {/* Selected Role Detail Card */}
      <div className="glass-card" style={{
        padding: '36px',
        borderColor: `rgba(${hexToRgb(selectedRole.color)}, 0.4)`,
        position: 'relative'
      }}>
        <div style={{
          display: 'flex',
          justify: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
          paddingBottom: '20px',
          marginBottom: '24px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ color: selectedRole.color, display: 'flex' }}>{selectedRole.icon}</span>
            <h3 style={{ fontSize: '1.8rem', color: '#ffffff', margin: 0 }}>
              {selectedRole.title} Track
            </h3>
          </div>
          <div style={{
            background: `rgba(${hexToRgb(selectedRole.color)}, 0.15)`,
            border: `1px solid ${selectedRole.color}`,
            color: selectedRole.color,
            padding: '8px 18px',
            borderRadius: '20px',
            fontWeight: '700',
            fontSize: '1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <FaCheckCircle /> {selectedRole.matchRate}
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '30px',
          marginBottom: '28px'
        }}>
          {/* Executive Summary & Business Impact */}
          <div>
            <h4 style={{ color: selectedRole.color, fontSize: '1.1rem', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaBriefcase /> Executive Overview
            </h4>
            <p style={{ color: '#e2e8f0', fontSize: '1rem', lineHeight: '1.6', marginBottom: '20px' }}>
              {selectedRole.summary}
            </p>

            <h4 style={{ color: selectedRole.color, fontSize: '1.1rem', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaGraduationCap /> Business Impact Proof
            </h4>
            <div style={{
              background: 'rgba(7, 19, 37, 0.6)',
              borderLeft: `4px solid ${selectedRole.color}`,
              padding: '14px 18px',
              borderRadius: '0 8px 8px 0',
              color: '#cbd5e1',
              fontSize: '0.95rem'
            }}>
              "{selectedRole.starImpact}"
            </div>
          </div>

          {/* Core Skills & Aligned Certifications */}
          <div>
            <h4 style={{ color: selectedRole.color, fontSize: '1.1rem', marginBottom: '12px' }}>
              Core Technical Competencies
            </h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '24px' }}>
              {selectedRole.coreSkills.map((skill, i) => (
                <span key={i} style={{
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  color: '#ffffff',
                  padding: '6px 14px',
                  borderRadius: '16px',
                  fontSize: '0.85rem',
                  fontWeight: '500'
                }}>
                  ✓ {skill}
                </span>
              ))}
            </div>

            <h4 style={{ color: selectedRole.color, fontSize: '1.1rem', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaCertificate /> Aligned Qualifications &amp; Certifications
            </h4>
            <ul style={{ paddingLeft: '20px', margin: 0, color: '#94a3b8', fontSize: '0.92rem' }}>
              {selectedRole.certifications.map((cert, idx) => (
                <li key={idx} style={{ marginBottom: '6px', color: '#cbd5e1' }}>
                  {cert}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Action Bar */}
        <div style={{
          display: 'flex',
          justify: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px',
          paddingTop: '20px',
          borderTop: '1px solid rgba(255,255,255,0.1)'
        }}>
          <div style={{ color: '#94a3b8', fontSize: '0.9rem' }}>
            Available for: <strong>Full-Time or part time Roles</strong> &amp; <strong>Freelance / Consulting Contracts</strong>
          </div>
          <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
            <Link
              to="/contact"
              className="btn-primary"
              style={{ background: `linear-gradient(135deg, ${selectedRole.color} 0%, #2b78e4 100%)` }}
            >
              {selectedRole.hrActionText} <FaArrowRight />
            </Link>
            <Link to="/contact" className="btn-secondary">
              {selectedRole.contractActionText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

// Helper function to convert Hex color to RGB string
function hexToRgb(hex) {
  const cleanHex = hex.replace('#', '');
  const bigint = parseInt(cleanHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `${r}, ${g}, ${b}`;
}

export default HrRoleMatcher;
